import {SupportedLanguageCode} from '@emma-labs/shared/typescript';

export class LanguageCache {
  private static language: SupportedLanguageCode | undefined = undefined;

  public static isLanguagePresent(): boolean {
    if (!LanguageCache.language) {
      LanguageCache.load();
    }
    return LanguageCache.language !== undefined;
  }

  public static get(): string {
    if (!LanguageCache.language) {
      LanguageCache.load();
    }
    return LanguageCache.language ?? '';
  }

  private static load() {
    const baseElement = document.head.querySelector('base');
    if (baseElement) {
      const baseHref = baseElement.getAttribute('href') || '';
      LanguageCache.language = baseHref.replace(/[^a-z]/g, '') as SupportedLanguageCode;
    }
  }
}
